<div (click)="colorsModal.show()" class="app-color-picker rounded-circle d-flex align-items-center justify-content-center app-cursor-pointer" [ngStyle]="{ 'background-color': color }">
  <i class="fad fa-eye-dropper {{ _brightness == 'dark' ? 'white-text' : 'text-elegant' }}"></i>
</div>

<div mdbModal #colorsModal="mdbModal" class="modal fade" style="overflow-y: scroll" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center flex-column">

        <i class="animated rotateIn {{itemColor}}-text far fa-eye-dropper fa-4x d-none d-sm-inline"></i>
        <i class="animated rotateIn {{itemColor}}-text far fa-eye-dropper fa-2x d-sm-none"></i>

        <h6 class="modal-title w-100 text-center">
          <div class="font-weight-bold text-elegant mt-1">{{ 'COLORS' | translate }}</div>
        </h6>

        <button type="button" size="sm" mdbBtn color="secondary" class="waves-light z-depth-0 px-2 m-0 app-close-modal" (click)="colorsModal.hide()" mdbWavesEffect>
          <i class="fas fa-times fa-fw"></i>
        </button>

      </div>
      <div class="modal-body overflow-hidden" *ngIf="colorsModal.isShown">
        
        <app-colors [color]="_color" (sendColor)="onSelect();colorsModal.hide();"></app-colors>

      </div>
    </div>
  </div>
</div>